<template>
    <div class="text-center">
        <LoadingSpinnerComponent v-bind:hide="!loading"/>
        <div v-if="step === 1" class="card p-4 w-fit ml-auto mr-auto">
            <h2>Leave a review</h2>
            <form @submit.prevent="findPpc">
                <div class="mb-5 mt-5">
                    <div class="input-group grid grid-cols-3">
                        <div
                            class="input-addon input-addon-prepend input-group-item col-span-1"
                        >
                            Email address
                        </div>
                        <so-input
                            required
                            v-model="form.email"
                            type="email"
                            :maxlength="99"
                            class="form-control input-group-item col-span-2"
                        />
                    </div>
                    <div class="input-group grid grid-cols-3 mt-4">
                        <div
                            class="input-addon input-addon-prepend input-group-item col-span-1"
                        >
                            Property ID
                        </div>
                        <so-input
                            required
                            :disabled="!!p_aid"
                            v-model="form.propertyNumber"
                            type="number"
                            class="form-control input-group-item col-span-2"
                        />
                    </div>
                    <div class="input-group grid grid-cols-3 mt-4">
                        <div
                            class="input-addon input-addon-prepend input-group-item col-span-1"
                        >
                            Start day
                        </div>
                        <input
                            required
                            type="date"
                            class="form-control input-group-item  col-span-2"
                            v-model="form.start"
                        />
                    </div>
                    <div class="input-group grid grid-cols-3 mt-4">
                        <div
                            class="input-addon input-addon-prepend input-group-item col-span-1"
                        >
                            End day
                        </div>
                        <input
                            :min="form.start"
                            required
                            :disabled="form.start === null"
                            type="date"
                            class="form-control input-group-item  col-span-2"
                            v-model="form.end"
                        />
                    </div>
                </div>
                <div class="mb5">
                    <button type="submit" class="btn btn_outlined btn_info">
                        <i class="la la-pen mr-2"></i>Write Review
                    </button>
                </div>
            </form>
        </div>
        <div v-if="step === 2" class="card p-4 w-fit ml-auto mr-auto">
            <WriteReviewComponent
                @loading="load"
                @stepChange="stepChange"
                :form="form"
                :property="property"
            />
        </div>
        <div v-if="step === 3" class="card p-4 w-fit ml-auto mr-auto">
            <div v-if="getHmInfo">
                <h3 class="mb-4">
                    Please enter your phone number in case we need to contact you about your stay.
                </h3>
                <form @submit.prevent="showReviewForm">
                    <div class="">
                        <div class="flex w-full">
                            <ValidationProvider
                                class="w-full"
                                v-slot="{ errors }"
                                name="Your Phone Number"
                                rules="max:45"
                                vid="phone"
                            >
                                <vue-tel-input
                                    v-model="phoneNumber"
                                    :dropdownOptions="{
                                        showFlags: true,
                                        showSearchBox: true,
                                        showDialCodeInList: true
                                    }"
                                    :inputOptions="{
                                        showDialCode: false,
                                        styleClasses: 'form-control',
                                        type: 'tel',
                                        id: 'phone'
                                    }"
                                    autoFormat
                                    class="text-sm tel-wrapper block"
                                    @input="phoneNumberChanged"
                                    @validate="telValidate"
                                ></vue-tel-input>
                                <span
                                    class="ml-1 block mt-0.5 text-sm text-red-600"
                                >{{ errors[0] }}</span
                                >
                            </ValidationProvider>
                        </div>
                        <div class="mb-2">
                            <div>
                                <div
                                    v-if="!validPhoneNumber"
                                    class="text-red-600 text-sm ml-1 mt-1"
                                >
                                    Please enter a valid phone number
                                </div>
                                <div
                                    v-if="validPhoneNumber"
                                    class="text-green-600 text-sm ml-1 mt-1"
                                >
                                    Phone number is valid:
                                    {{ validPhoneNumberObject.number }}
                                </div>
                            </div>
                        </div>
                        <ButtonSO
                            :disabled="!validPhoneNumber"
                            class="p-2"
                            style="height: min-content"
                            icon="las la-fast-forward"
                            text="Next"
                            btn-type="btn_info"
                            type="submit"
                        >
                        </ButtonSO>
                    </div>
                </form>
            </div>
            <WriteReviewComponent
                v-else
                @loading="load"
                @stepChange="stepChange"
                :form="form"
                :property="property"
            />
        </div>

        <div v-if="step === 4" class="card p-4 w-fit ml-auto mr-auto">
            <h2>Thank you, review has been submitted!</h2>
        </div>
    </div>
</template>
<script>
import SoInput from "../ui/SoInput.vue";
import LoadingSpinnerComponent from "../LoadingSpinnerComponent.vue";
import WriteReviewComponent from "./WriteReviewComponent.vue";
import ButtonSO from "../ui/ButtonSO.vue";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {email, max, required} from "vee-validate/dist/rules";
import {VueTelInput} from "vue-tel-input";

extend("max", {
    ...max,
    message: "{_field_} must be under {length} characters"
});

export default {
    name: "LeaveReviewComponent",
    props: ["p_aid"],
    components: {
        ButtonSO,
        WriteReviewComponent,
        LoadingSpinnerComponent,
        SoInput,
        ValidationProvider,
        ValidationObserver,
        VueTelInput
    },
    methods: {
        findPpc() {
            this.loading = true;
            axios
                .post("/leave-review/find-ppc", {
                    form: this.form
                })
                .then(response => {
                    if (response.data.success) {
                        if (response.data.has_review) {
                            this.$swal({
                                icon: "error",
                                title: "Error!",
                                text: response.data.message
                            });
                        } else {
                            this.form.ppc_id = response.data.ppc_id;
                            this.property = response.data.property;
                            this.step = 2;
                            this.successSweetAlert(
                                response,
                                "success",
                                response.data.message
                            );
                        }
                    } else {
                        if (response.data.no_property) {
                            this.$swal({
                                icon: "error",
                                title: "Error!",
                                text: response.data.message
                            });
                        } else {
                            this.property = response.data.property;
                            this.getHmInfo = true;
                            this.step = 3;
                        }
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.$swal({
                        icon: "error",
                        title: error.status,
                        text: error.response.data.message
                    });
                    this.loading = false;
                });
        },
        load(status) {
            this.loading = status;
        },
        stepChange(status) {
            this.step = status;
        },
        showReviewForm() {
            this.getHmInfo = false;
        },
        phoneNumberChanged(phoneNumber, phoneNumberObject) {
            this.validPhoneNumberObject = phoneNumberObject;
            if (phoneNumberObject.valid) {
                this.validPhoneNumber = phoneNumberObject.number;
                this.form.phoneNumber = phoneNumberObject.number;
            }
        },
        telValidate(telnumber) {
            this.validPhoneNumberObject = telnumber;
            telnumber.valid
                ? (this.validPhoneNumber = telnumber.number)
                : (this.validPhoneNumber = "");
        }
    },
    data() {
        return {
            form: {
                email: null,
                propertyNumber: this.p_aid,
                start: null,
                end: null,
                ppc_id: null,
                phoneNumber: null
            },
            property: null,
            loading: false,
            step: 1, // step 1 - get stay info, step 2 - PPC found, let add review, step 3 - No PPC - get phone and let add review, step 4 - show success info
            getHmInfo: false,
            validPhoneNumber: false,
            validPhoneNumberObject: null,
            phoneNumber: null
        };
    }
};
</script>
<style src="vue-tel-input/dist/vue-tel-input.css"></style>
